import createAxiosInstance from './axiosConfig';

export interface DataRequest {
  Document: string;
}

export interface DataCheckupRequest {
  Document: string;
  Email?: Array<{ Email: string }>;
  Phones?: Array<{ Area: number; Number: string }>;
  Address?: Array<{
    Alias?: string;
    City?: string;
    Number?: string;
    Street?: string;
    ZipCode?: string;
  }>;
}

export interface SearchRequest {
  Name?: string;
  Street?: string;
  City?: string;
  ZipCode?: string;
  AddressNumber?: string;
  Radius?: number;
}

interface AddressSubset { FullAddress: string | null; 
  City: string; 
  State:string;
  ZipCode: number;
  District: string;
  Alias: string | null; }
interface EmailSubset { Email: string; }
interface PhoneSubset { FormattedNumber: string; IsWhatsapp: boolean; }
interface DataSubset { Name: string; DocumentFormatted: string; Gender: string; BirthDate: string; Addresses: AddressSubset[]; Emails: EmailSubset[]; Phones: PhoneSubset[]; }
export interface SimplifiedDataResponse { Data: DataSubset; RequestId: string; }

export interface EmailResult { Value: number; Email: string; }
export interface PhoneResult { Value: number; Area: number; Number: string; }
export interface AddressResult {
    Value: number;
    Alias: string | null;
    Street: string;
    Number: string;
    City: string;
    State: string;
    ZipCode: string;
}

export interface CheckupData {
    Flags: number;
    Email: EmailResult[];
    Phone: PhoneResult[];
    Address: AddressResult[];
}

export interface DataCheckupResponse {
    Data: CheckupData | null;
    RequestId: string;
    Timestamp: string;
    Status: number;
    Error: string | null;
    Duration: number;
}

export interface SearchResponseItem {
    PersonType: number;
    SequentialId: number;
    Name: string;
    Probability: number;
    IsFromBlackList: boolean;
    Flags: number;
    Age: number;
    DocumentFmt: string;
    MotherNameFmt: string;
    Location: string;
}

export interface SpiderRequest {
  input: {
    cpf?: string;
    dataNascimento?: string;
    cpfCnpj_In?: string;
    apiType_In?: string;
  }
}

export interface SpiderBaseResponse<T> {
  duration: number;
  requestId: string;
  timestamp: string;
  status: number;
  data: T[];
}

export interface ReceitaFederalData {
  id: number;
  cpf: string;
  nome: string;
  situacaoCadastral: string;
  dataNascimento: string;
  codigoDeControle: string;
}

export interface ProcessoJuridicoData {
  id: number;
  numeroProcessoUnico: string;
  tribunal: string;
  area: string;
  causaValor: number;
  partes: Array<{
    tipo: string;
    nome: string;
    polo: string;
    cpf?: string;
    cnpj?: string;
  }>
}

const { REACT_APP_ESTEIRA_BACK } = process.env;

export default class Ph3aService {
  private axios;

  constructor() {
    this.axios = createAxiosInstance(`${REACT_APP_ESTEIRA_BACK}/rest/ph3a`);
  }

  async consultarDados(idPromotora: number, requestBody: DataRequest): Promise<SimplifiedDataResponse> {
    try {
      const response = await this.axios.post<SimplifiedDataResponse>(`/${idPromotora}/dados`, requestBody);
      return response.data;
    } catch (error) {
      console.error('Erro ao consultar dados:', error);
      throw error;
    }
  }

  async realizarCheckup(idPromotora: number, requestBody: DataCheckupRequest): Promise<DataCheckupResponse> {
    try {
      const response = await this.axios.post<DataCheckupResponse>(`/${idPromotora}/checkup`, requestBody);
      return response.data;
    } catch (error) {
      console.error('Erro ao realizar checkup:', error);
      throw error;
    }
  }

  async buscarPorCriterios(idPromotora: number, page: number, size: number, requestBody: SearchRequest): Promise<SearchResponseItem[]> {
    try {
      const response = await this.axios.post<SearchResponseItem[]>(`/${idPromotora}/search/${page}/${size}`, requestBody);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar por critérios:', error);
      throw error;
    }
  }

  async consultarPorRequestId(idPromotora: number, requestId: string): Promise<SimplifiedDataResponse> {
    try {
      const response = await this.axios.get<SimplifiedDataResponse>(`/${idPromotora}/request/${requestId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao consultar por Request ID:', error);
      throw error;
    }
  }

  async dispararSpider(idPromotora: number, requestBody: SpiderRequest): Promise<any> {
    try {
      const response = await this.axios.post(`/${idPromotora}/spider`, requestBody);
      return response.data;
    } catch (error) {
      console.error('Erro ao disparar consulta Spider:', error);
      throw error;
    }
  }

  async obterResultadoReceita(idPromotora: number, requestId: string): Promise<SpiderBaseResponse<ReceitaFederalData>> {
    try {
      const response = await this.axios.get<SpiderBaseResponse<ReceitaFederalData>>(
        `/${idPromotora}/spider/resultado/receita/${requestId}`
      );
      return response.data;
    } catch (error) {
      console.error('Erro ao obter resultado da Receita:', error);
      throw error;
    }
  }

  async obterResultadoProcessos(idPromotora: number, requestId: string): Promise<SpiderBaseResponse<ProcessoJuridicoData>> {
    try {
      const response = await this.axios.get<SpiderBaseResponse<ProcessoJuridicoData>>(
        `/${idPromotora}/spider/resultado/processos/${requestId}`
      );
      return response.data;
    } catch (error) {
      console.error('Erro ao obter resultado de Processos:', error);
      throw error;
    }
  }
}